import { Json } from "@/integrations/cloudflare/types";
import { BlogPostMetadata } from "@/types/blogTypes";

// Helper function to safely parse metadata
export function parseMetadata(metadata: Json | null): BlogPostMetadata {
  if (!metadata) return {};
  
  // If metadata is already an object, use it
  if (typeof metadata === 'object' && metadata !== null && !Array.isArray(metadata)) {
    return {
      author: typeof metadata.author === 'string' ? metadata.author : undefined,
      seo_description: typeof metadata.seo_description === 'string' ? metadata.seo_description : undefined,
      theme: typeof metadata.theme === 'string' ? metadata.theme : undefined,
      categories: Array.isArray(metadata.categories) ? metadata.categories.filter(c => typeof c === 'string') as string[] : undefined
    };
  }
  
  // Otherwise return empty object
  return {};
}
